module.exports = __webpack_public_path__ + "static/media/TSV-prosessi-materiaalitori-kuva-Tiina-Paju-web.88f75e03.png";